import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {EChartsOption} from 'echarts';

@Component({
    selector: 'app-tree-chart',
    templateUrl: './tree-chart.component.html',
    styleUrls: ['./tree-chart.component.css']
})
export class TreeChartComponent implements OnInit, OnDestroy {
    @Input() options!: EChartsOption;
    @Input() chartKey!: string;
    @Output() chartInit = new EventEmitter<{ instance: any, key: string }>();
    @Output() chartClick = new EventEmitter<{ event: any, key: string }>();

    @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;

    private chartInstance: any;
    private resizeObserver?: ResizeObserver;

    ngOnInit(): void {}

    onChartInit(ec: any): void {
        this.chartInstance = ec;
        this.chartInit.emit({ instance: ec, key: this.chartKey });
        this.resizeObserver = new ResizeObserver(() => this.chartInstance?.resize());
        this.resizeObserver.observe(this.chartContainer.nativeElement);
    }

    onChartClick(event: any): void {
        this.chartClick.emit({ event, key: this.chartKey });
    }

    ngOnDestroy(): void {
        this.resizeObserver?.disconnect();
    }
}
